import { ActionStatus, Room } from '../../../Constants';
import {
    debrisOnStation,
    isThereACoreRoomInStorage,
    upgradedAmenitiesAndBedsInStorage,
    upgradedCoreRoomInStorage
} from '../../Game/GamePlayerInfo';
import { isRoomActivated } from '../../TwoD/Common/StationUtilities';


function install(gamePlayerController, aiPackage, stationIndex, storageIndex) {
    if (aiPackage.execute && storageIndex !== null) {
        gamePlayerController.gamePlayerApi.installFromStorage(stationIndex, storageIndex);
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}

function uninstall(gamePlayerController, aiPackage, stationIndex) {
    if (aiPackage.execute && stationIndex !== null) {
        gamePlayerController.gamePlayerApi.uninstallToStorage(stationIndex);
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function coreRooms(gamePlayerController, aiPackage) {
    let question = 'Is there an upgraded Core Room in storage?';
    let result = false;
    let reasoning = 'Get core rooms re-installed as soon as possible.';
    let storageIndex = upgradedCoreRoomInStorage(gamePlayerController.gamePlayerData);
    let stationIndex = null;
    if (storageIndex != null) {
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        if (roomId) {
            stationIndex = gamePlayerController.gamePlayerData.station.indexOf(
                Room.RANDOM_ACTION_ROOM_ID);
            // stationIndex === -1 means there is no emptied core-room slot (no
            // RANDOM_ACTION placeholder) to re-install into. Without this
            // stationIndex >= 0 guard install() fires installFromStorage(-1, ..)
            // and the engine reads destination=-1 as a negative Python index
            // (the LAST station slot). Leave success false so aiRenovate falls
            // through to extraRooms/debris/coreRoom -> clickNext.
            if (stationIndex >= 0 &&
                    !gamePlayerController.gamePlayerData.locked_rooms.includes(stationIndex)) {
                result = true;
                aiPackage.addToMessage(`Re-Install ${Room.NAMES[roomId]}`);
                aiPackage.success = true;
            }
        }
    }
    aiPackage.addProvenance(question, result, reasoning);
    return { stationIndex:stationIndex, storageIndex:storageIndex };
}

function extraRooms(gamePlayerController, aiPackage) {
    const question = 'Are there any upgraded Beds or Amenities to install?'
    const storageIndex = upgradedAmenitiesAndBedsInStorage(gamePlayerController.gamePlayerData);
    let stationIndex = null;
    let result = false;
    const reasoning = 'Install Beds and Amenities into empty spaces.'
    if (storageIndex != null) {
        const roomId = gamePlayerController.gamePlayerData.storage[storageIndex];
        stationIndex = gamePlayerController.gamePlayerData.station.indexOf(null);
        if (stationIndex >= 0) {
            result = true;
            aiPackage.addToMessage(`Install ${Room.NAMES[roomId]}`);
            aiPackage.success = true;
        }

    }
    aiPackage.addProvenance(question, result, reasoning);
    return { stationIndex:stationIndex, storageIndex:storageIndex };
}

function debris(gamePlayerController, aiPackage) {
    const question = 'Is there debris?'
    const stationIndex = debrisOnStation(gamePlayerController.gamePlayerData);
    let result = false;
    const reasoning = 'Debris is worth Snohe if Uninstalled.'
    if (stationIndex != null) {
            result = true;
            aiPackage.addToMessage(`Uninstall Debris`);
            aiPackage.success = true;
        }
    aiPackage.addProvenance(question, result, reasoning);
    return stationIndex;
}

function coreRoom(gamePlayerController, aiPackage) {
    let question = 'Is there an upgraded Core Room in storage?';
    let result = isThereACoreRoomInStorage(gamePlayerController.gamePlayerData);
    let reasoning = 'I never uninstall more than 1 Core room at a time.';
    aiPackage.addProvenance(question, result, reasoning);
    if (result) return null;
    // # advertisement, robot, lodging, renovation, ghost, research
    const upgrade_order = [6, 4, 10, 8, 12, 2];
    let stationIndex = null;
    for ( const targetRoomId of upgrade_order) {
        if (gamePlayerController.gamePlayerData.station.includes(targetRoomId)) {
            stationIndex = gamePlayerController.gamePlayerData.station.indexOf(
                targetRoomId);
            if (!isRoomActivated(gamePlayerController.gamePlayerData, stationIndex)) {
                aiPackage.addToMessage(`Uninstall Core Room ${Room.NAMES[targetRoomId]}`);
                aiPackage.success = true;
                break;
            }
        }
    }
    return stationIndex;
}

export function aiRenovate(gamePlayerController, aiPackage) {
    let result = coreRooms(gamePlayerController, aiPackage);
    if (!aiPackage.success) {
        result = extraRooms(gamePlayerController, aiPackage);
    }
    if (aiPackage.success) {
        install(gamePlayerController, aiPackage,
            result.stationIndex, result.storageIndex);
        return;
    }

    result = debris(gamePlayerController, aiPackage);
    if (!aiPackage.success) {
        result = coreRoom(gamePlayerController, aiPackage);
    }
    if (aiPackage.success) {
        uninstall(gamePlayerController, aiPackage, result)
        return;
    }

    // todo: renovation sell.

    aiPackage.success = false;
    aiPackage.addToMessage(`I don't want to Renovate`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}

export default function artificialRenovationAction(gamePlayerController, aiPackage) {
    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiPackage.addToMessage('Renovation Initializing');
        return aiPackage;
    case ActionStatus.WAIT_ID:
        return aiRenovate(gamePlayerController, aiPackage);
    default:
        break;
    }
}
